/*****
 * Created by Allan on 2022/03/22.
 * Modification Time 2023/02/07
 * Contact 84880528@qq.com.
 * *****/
import Vue from 'vue'
import router from '@/router/'
import moment from 'moment-timezone'
import store from './index'
import Http from '@/services/http/'
import { deleteCookie } from '@/services/cookieFunction'

export default{
    state:{
        user:JSON.parse(localStorage.getItem('user')) || {},  //当前用户信息
        timeZoneDate:localStorage.getItem('timeZoneDate'),  //当前时区时间
    },
    //Getter 接受 state 作为其第一个参数,可以接受其他 getter 作为第二个参数
    getters:{
        getUsers:state=>state.user,
        timeZoneDate:state=>state.timeZoneDate,
    },
    //state 作为第一个参数
    mutations:{
        mutationUser(state,data){
            localStorage.setItem('user',JSON.stringify(data));
            state.user=data;
        },
        mutationUserSignout(state){
            localStorage.clear();
            deleteCookie('mobile');
            deleteCookie('username');
            deleteCookie('userId');
            deleteCookie('SERVERID');
            deleteCookie('ADMINJSESSIONID');
            router.replace({path:'/login'});
            window.location.reload();
            Object.keys(state).forEach(k => Vue.delete(state, k))
        },
        setTimeZoneDate(state,data){
            let timeZone=state.user.timeZone;
            let currData=moment().tz(timeZone).format("MM-DD");
            let currTime=moment().tz(timeZone).format("HH:mm");
            let week=moment().tz(timeZone).weekday();
            let weekText='';
            switch(week){
                case 1:weekText='周一';
                break;
                case 2:weekText='周二';
                break;
                case 3:weekText='周三';
                break
                case 4:weekText='周四';
                break;
                case 5:weekText='周五';
                break;
                case 6:weekText='周六';
                break;
                case 0:weekText='周日';
            }
            let timeZoneDate=currData+' '+weekText+' '+currTime;
            localStorage.setItem('timeZoneDate',timeZoneDate);
            state.timeZoneDate=timeZoneDate;
        },
    },
    //Action 提交的是 mutation，而不是直接变更状态
    actions:{
        actionUser({ commit }, data){
            commit('mutationUser', data)
        },
        actionUserSignout({ commit }){
            commit('mutationUserSignout')
        },
        getTimeZoneDate({ commit }, data){
            commit('setTimeZoneDate')
        },
    },
}



// WEBPACK FOOTER //
// ./src/store/user.js